import { Camera } from '@babylonjs/core/Cameras/camera';
import { Token } from '@kb3d/models/classes/token';
import { ViewpointNode } from '@kb3d/models/classes/viewpoints/viewpoint-node';
import { ITrackedClass } from '@kb3d/models/interfaces';
import { Renderer } from './renderer';

export class ViewpointRenderer extends Renderer<ViewpointNode, Camera> {
    modelToken = Token.ViewpointNode;
    update3dInternal(node: ITrackedClass<ViewpointNode>) {}
}
